import { useParams } from 'react-router-dom';
import SideBar from '../../components/global/SideBar';
import './index.css';
import { PartnerProfile, useCurrentUser } from '@beholos/holoscommon';
import { usePageTitle } from '../../hooks/usePageTitle';

export default function PartnerProfilePage() {
  const { partnerSlug } = useParams();
  const currentUser = useCurrentUser();

  usePageTitle('Partner - Holos');

  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      {currentUser.user && <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>}

      <div className="flex-1 h-full overflow-y-auto pb-6 md:pt-6">
        <PartnerProfile slug={partnerSlug} />
      </div>
    </div>
  );
}
